// 埋点监听
export const createIntersectionObserver = (targetElement, attributeName, stayVisibleCallback) => {
	let arr = [];
	let timer = {};
	const observer = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				let id = '';
				id = entry.target.getAttribute(attributeName);
				if (id == 'null') {
					return false;
				}
				if (entry.isIntersecting) {
					// 当目标元素完全进入可视区域时执行的代码
					let goodId = entry.target.getAttribute('data-goodId');
					let gameId = entry.target.getAttribute('data-gameId');
					arr.push(id);
					// 使用setTimeout来延迟1.5秒后执行其他方法
					timer[id] = setTimeout(async () => {
						if (arr.includes(id)) {
							if (typeof stayVisibleCallback === 'function') {
								await stayVisibleCallback(id, goodId, gameId); // 执行传递的回调函数
								clearTimeout(timer[id]); // 清除之前的定时器
								delete timer[id];
								arr = arr.filter((item) => item !== id);
								id = '';
							}
						}
					}, 1500);
					// 移除观察者，因为我们只关心目标元素首次变得完全可见的情况
					// observer.unobserve(entry.target);
				} else {
					// 当目标元素不在可视区域时执行的代码
					clearTimeout(timer[id]); // 清除之前的定时器
					delete timer[id];
					arr = arr.filter((item) => item !== id);
					id = '';
				}
			});
		},
		{
			threshold: 0.8 // 将字符串转为浮点数
		}
	);

	// 获取所有目标元素并开始观察
	Array.from(targetElement).map((element) => {
		observer.observe(element);
	});

	// 返回观察器实例，以便可以调用unobserve方法
	return observer;
};



// WEBPACK FOOTER //
// ./src/util/index.js